const INTERNAL_ROLE_ALIASES = new Set([
  'internal',
  'reports',
  'company_reports',
  'company',
]);

const CARDS_ADMIN_ROLE_ALIASES = new Set([
  'cards_admin',
  'cards-admin',
  '13',
]);

export function normalizeUserRole(role) {
  if (role === undefined || role === null || role === '') {
    return '';
  }

  const value = String(role).trim().toLowerCase();

  if (CARDS_ADMIN_ROLE_ALIASES.has(value)) {
    return 'cards_admin';
  }

  if (INTERNAL_ROLE_ALIASES.has(value)) {
    return 'internal';
  }

  return String(role).trim();
}

export function extractUserRoleFromLoginResult(result) {
  if (!result || typeof result !== 'object') {
    return '';
  }

  const candidates = [
    result.UserRole,
    result.userRole,
    result.Role,
    result.role,
    result.IdRole,
    result.idRole,
    result.id_role,
    result.role_id,
    result.RoleId,
    result.roleId,
  ];

  for (const candidate of candidates) {
    if (candidate !== undefined && candidate !== null && candidate !== '') {
      const normalized = normalizeUserRole(candidate);
      if (normalized) {
        return normalized;
      }
    }
  }

  return '';
}

export function extractUserRoleFromToken(token) {
  if (!token || typeof token !== 'string') {
    return '';
  }

  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return '';
    }

    const pad =
      parts[1].length % 4 === 0 ? '' : '='.repeat(4 - (parts[1].length % 4));
    const payload = JSON.parse(
      decodeURIComponent(
        atob(parts[1].replace(/-/g, '+').replace(/_/g, '/') + pad)
          .split('')
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join('')
      )
    );

    return extractUserRoleFromLoginResult(payload);
  } catch (error) {
    return '';
  }
}

export function resolveUserRoleFromLoginResult(result) {
  const fromFields = extractUserRoleFromLoginResult(result);
  if (fromFields) {
    return fromFields;
  }

  return extractUserRoleFromToken(result?.Token);
}

export function syncStoredUserRole() {
  const storedRole = localStorage.getItem('userRole');
  const normalized = normalizeUserRole(storedRole);
  if (normalized && normalized !== storedRole) {
    localStorage.setItem('userRole', normalized);
  }
  return normalized || storedRole || '';
}

export function isInternalUserRole(role) {
  return normalizeUserRole(role) === 'internal';
}

export function isCardsAdminUserRole(role) {
  return normalizeUserRole(role) === 'cards_admin';
}
